<template>
  <div class="IpPaymentpage">
    <div class="IpPaymentinfo">
      <p>
        <span>姓名：</span>
        <span>{{PatInfo.PatName}}({{PatInfo.IpNo}})</span>
      </p>
      <p>
        <span>入院科室：</span>
        <span>{{PatInfo.IpDptName}}</span>
      </p>
      <p>
        <span>入院日期：</span>
        <span class="mr18">{{PatInfo.IpDate}}</span>
      </p>
      <p>
        <span>预交金金额</span>
      </p>
      <p class="money">
        <em>￥</em>
        <input type="text" id="czMoney" v-model="money" @blur="moneyBlur" />
      </p>
      <p class="zs">
        <span>或选择缴纳金额（元）</span>
      </p>
      <p class="moneychoose">
        <span :class="[cMoney == 500 ? 'on' : '']" @click="chooseMoney(500)">500</span>
        <span :class="[cMoney == 1000 ? 'on' : '']" @click="chooseMoney(1000)">1000</span>
        <span :class="[cMoney == 2000 ? 'on' : '']" @click="chooseMoney(2000)">2000</span>
      </p>
      <p class="btn">
        <span @click="CanIpPayment()">立即充值</span>
      </p>
    </div>
  </div>
</template>
<script>
import {
  GetIpPatInfo,
  GetItem,
  CanIpPayment,
  WeiXinCharge
} from "@/services/getData.js";
import BScroll from "better-scroll";
import weui from "weui.js";
import moment from "moment";
export default {
  name: "inspection-result",
  created: function() {
    this.GetIpPatInfo();
  },
  data() {
    return {
      cMoney: 0,
      money: 0,
      PatInfo: {
        PatName: "",
        IpDptName: "",
        IpDate: "",
        IpNo: ""
      },
      moment: moment
    };
  },
  methods: {
    chooseMoney: function(money) {
      if (money == this.cMoney) {
        this.cMoney = 0;
      } else {
        this.cMoney = money;
        this.money = money;
      }
    },
    moneyBlur: function() {
      this.cMoney = 0;
    },
    GetIpPatInfo: function() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetIpPatInfo(GetItem("patid"), GetItem("hosid")).then(response => {
        loading.hide();
        var _this = this;
        if (response.data.Result) {
          //跳转到主页
          this.PatInfo = response.data.Extend;
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content,
            buttons: [
              {
                label: "确定",
                type: "primary",
                onClick: function() {
                  _this.$router.back(-1);
                }
              }
            ]
          });
        }
      });
    },
    CanIpPayment: function() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });

      var numberBool =/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(this.money);
      if (!numberBool) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请输入正确的金额",
          buttons: [
            {
              label: "确定",
              type: "primary",
              onClick: function() {}
            }
          ]
        });
        loading.hide();
        return;
      }
      if (this.money <= 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "金额必须大于0"
        });
        loading.hide();
        return;
      }

      //判断是否可以充值预交金
      CanIpPayment(this.PatInfo.IpNo, GetItem("hosid")).then(response => {
        loading.hide();
        var _this = this;
        if (response.data.Result) {
          _this.IpPaymentAmount();
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content,
            buttons: [
              {
                label: "确定",
                type: "primary",
                onClick: function() {}
              }
            ]
          });
        }
      });
    },
    IpPaymentAmount: function() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });

      var sendData = {
        IpNo: this.PatInfo.IpNo,
        Amount: this.money,
        OutNumber: "",
        HosID: GetItem("hosid")
      };

      var sendPayinfo = {
        OpenId: GetItem("openid"),
        HosID: GetItem("hosid"),
        PatID: GetItem("patid"),
        Type: 3,
        ChargeData: JSON.stringify(sendData),
        Amount: this.money
      };

      var _that = this;
      WeiXinCharge(sendPayinfo).then(data => {
        var returnString = data.split("_");
        if (returnString[0] == "ok") {
          loading.hide();
          this.$router.push({
            path: "/IpPayment/IpPaymentRecord",
            query: { ipNo: _that.PatInfo.IpNo }
          });
        } else if (returnString[0] == "cancel") {
          DeletePayRecord(returnString[1]).then(response => {
            loading.hide();
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "fail") {
          DeletePayRecord(returnString[1]).then(response => {
            loading.hide();
            if (response.data.Result) {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: "支付失败"
              });
            } else {
              _that.$dialog = weui.dialog({
                title: "提示",
                content: response.data.Content
              });
            }
          });
        } else if (returnString[0] == "no") {
          loading.hide();
        } else {
          loading.hide();
        }
      });
    }
  }
};
</script>
<style lang="scss">
.IpPaymentpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.IpPaymentpage .IpPaymentinfo {
  width: 100%;
  box-sizing: border-box;
  padding: 0.2rem;
  background: #ffffff;
}
.IpPaymentpage .IpPaymentinfo > p {
  width: 100%;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.IpPaymentpage .IpPaymentinfo > p.money {
  width: 100%;
  height: 0.6rem;
  display: block;
  font-size: 0.3rem;
  color: #333333;
  position: relative;
}
.IpPaymentpage .IpPaymentinfo > p.money em {
  position: absolute;
  top: 0.08rem;
}
.IpPaymentpage .IpPaymentinfo > p.money input {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  text-indent: 0.4rem;
  border-bottom: solid 0.01rem rgba(221, 221, 221, 1);
}
.IpPaymentpage .IpPaymentinfo > p.zs {
  height: 0.6rem;
  line-height: 0.6rem;
  color: #999999;
}
.IpPaymentpage .IpPaymentinfo > p.moneychoose {
  height: 0.8rem;
  display: flex;
}
.IpPaymentpage .IpPaymentinfo > p.moneychoose span {
  display: block;
  flex: 1;
  height: 0.6rem;
  line-height: 0.6rem;
  margin-right: 0.4rem;
  text-align: center;
  border: solid 0.01rem rgba(221, 221, 221, 1);
  border-radius: 0.08rem;
}
.IpPaymentpage .IpPaymentinfo > p.moneychoose span.on {
  border: solid 0.01rem #3d97d1;
}
.IpPaymentpage .IpPaymentinfo > p.moneychoose span:last-child {
  margin-right: 0;
}
.IpPaymentpage .IpPaymentinfo > p.btn {
  height: 0.8rem;
  padding: 0.2rem 0;
}
.IpPaymentpage .IpPaymentinfo > p.btn span {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  display: block;
  border-radius: 0.08rem;
  text-align: center;
  font-size: 0.28rem;
  background: #3d97d1;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/IpPayment/IpPayment.vue